import React from 'react'
import SectionSeparator from '../../pb_section_separator/_section_separator'

const SectionSeparatorLine = (props) => {
  return (
    <div>
      <SectionSeparator
          {...props}
      />
    </div>
  )
}

export default SectionSeparatorLine
